import React from "react";
import axios from "axios";
import { MdLocationPin, MdCheck, MdContentCopy, MdMap } from "react-icons/md";
import { FaInfoCircle, FaCheckCircle } from "react-icons/fa";
import { selectSystem, setMap, setView } from "amadeusredux/lib/systemSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  propertyFromArray,
  boardTypes,
  roomTypes,
  stars,
  getTexts,
  hotelAttributes,
  views,
  getHost,
} from "../utils";
import {
  selectSearch,
  setApicall,
  setInbounddate,
  setOutbounddate,
} from "amadeusredux/lib/searchSlice";
import { getLink2Share, search, setOfferMemo } from "amadeusredux/lib/api";
import {
  getCityInfo,
  setHotelOfferInfos,
  setHotelPage,
  setOfferId,
  setSelectedHotel,
} from "amadeusredux/lib/hotelSlice";
import { sendLink2Agency } from "amadeusredux/lib/bookingSlice";
import { FormattedMessage } from "react-intl";
import CancellationOptions from "../CancellationOptions";
import OfferImage from "./OfferImage";
import { setMarked, setSelectedOfferId } from "amadeusredux/lib/offersSlice";
import { FaHeart, FaShareAlt } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";
import MarketingBox from "../marketing/MarketingBox";
import Popup from "reactjs-popup";
import InfoPopup from "../components/InfoPopup";
import InfoPopupHover from "../components/InfoPopupHover";
import { BsSuitHeartFill, BsSuitHeart } from "react-icons/bs";

import { FiUpload, FiShare2 } from "react-icons/fi";

import { RiCloseFill } from "react-icons/ri";

const nf = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2 });
const nf1 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
const nf2 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export default function OfferFrame(props) {
  const { offer, hotels, geodata, setHotelIndex, offerInfos } = props;
  const sessionId = useSelector((state) => state.system.sessionId);
  const holidayType = useSelector((state) => state.search.holidayType);
  const [shareOptionsHidden, setShareOptionsHidden] = React.useState(true);
  const [shareLink, setShareLink] = React.useState({});
  const searchOptions = useSelector(selectSearch);
  const hotelAttribute = useSelector((state) => state.search.hotelAttribute);
  const features = useSelector((state) => state.system.features);
  const cityInfo = useSelector((state) => state.hotel.cityInfo);

  const multiroomdivider = useSelector(
    (state) => state.search.multiroomdivider
  );

  const touroperatorsForHotel = useSelector(
    (state) => state.filter.touroperatorsForHotel
  );

  const [pictIdx, setPictIdx] = React.useState(0);
  const [popupOpen, setPopupOpen] = React.useState(false);
  const [uploadStep, setUploadStep] = React.useState(0);
  const [uploadOpen, setUploadOpen] = React.useState(false);
  const [requestData, setRequestData] = React.useState({
    name: "",
    mail: "",
    phone: "",
    remark: "",
  });
  const infos = useSelector((state) => state.properties.infos);

  const [galleryUrls, setGalleryUrls] = React.useState([]);

  //console.log(offer.MarketingActions);
  const hotel = hotels.Hotel.find(
    (e) =>
      e.HotelID === offer.OfferServices.Package.Accommodation.HotelRef.HotelID
  );
  const { loading } = useSelector(selectSystem);
  const dispatch = useDispatch();
  /*React.useEffect(() => {
    dispatch(getCityInfo({id:hotel.HotelLocationRef.CityID}));
  }, []);
  */
  //console.log(galleryUrls);
  React.useEffect(() => {
    axios
      .get(
        getHost() +
          "/giatagallery/" +
          encodeURIComponent(hotel?.HotelCodes?.HotelGiataID)
      )
      .then((response) => {
        //console.log(response.data.result.data);

        let catidx = -1;
        let piccnt = 0;

        if (
          Array.isArray(response?.data?.result?.data) &&
          response?.data?.result?.data.length > 0
        ) {
          for (let i = 0; i < response.data.result.data.length; i++) {
            //console.log(response.data.result.data[0]);
            if (Array.isArray(response.data.result.data[i].Bildfile)) {
              if (response.data.result.data[i].Bildfile.length > piccnt) {
                piccnt = response.data.result.data[i].Bildfile.length;
                catidx = i;
              }
            }
          }
        }

        if (catidx > -1) {
          setGalleryUrls(
            response.data.result.data[0].Bildfile.map((e) => e["_"])
          );
        }
      });
  }, [hotel]);

  let transferincl = false;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferincl = true;
    }
  }
  let txts = getTexts(offer.OfferProperties?.OfferFeatures, [
    "Storno:",
    "Storno mit Gebühr:",
    "Umb:",
    "Opt Flex:",
    "Sonst:",
  ]);
  //  console.log(offer);
  let railandfly = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandfly = true;
    }
  }
  let freeRebook = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("FreeRebooking")
    ) {
      freeRebook = true;
    }
  }

  let rentalCar = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RentalCar")
    ) {
      rentalCar = true;
    }
  }

  //console.log(infos);

  return (
    <>
      <InfoPopup
        popupOpen={popupOpen}
        setPopupOpen={(val) => setPopupOpen(val)}
        text={
          Array.isArray(cityInfo) && cityInfo.length > 0
            ? cityInfo[0].description
            : ""
        }
      />

      <div
        className={
          offer.topseller ? "offerhotelinfotopseller" : "offerhotelinfo"
        }
      >
        {offer.topseller && (
          <div className="topsellerrecommendframe">
            <div className="topsellerrecommend">Unsere Empfehlung</div>
          </div>
        )}

        {offer.topseller && (
          <div className="topsellerimgframe">
            <InfoPopupHover
              trigger={
                <img
                  src="https://holiday.placelogg.com/holidaymedia/topangebot.png"
                  className="topsellerimg"
                ></img>
              }
              content={offer.topsellertext}
              position={"bottom center"}
            ></InfoPopupHover>{" "}
          </div>
        )}
        {/*Array.isArray(offer?.MarketingActions) && offer.MarketingActions.length > 0 && <div>{offer.MarketingActions[0].roomnames}</div>*/}
        <div style={{ flexGrow: 1 }}>
          <MarketingBox offer={offer} onpage="0021-0002" />
        </div>
        <div className="offerhotellocation" style={{ paddingLeft: 16 }}>
          Dieses Hotel wird im ausgewählten Zeitraum von&nbsp;
          {hotel?.HotelCodes?.HotelIffCode &&
            Array.isArray(touroperatorsForHotel) &&
            touroperatorsForHotel.length > 0 &&
            touroperatorsForHotel.filter(
              (e) => e.HotelIffCode === hotel.HotelCodes.HotelIffCode
            ) && (
              <span>
                {
                  touroperatorsForHotel.filter(
                    (e) => e.HotelIffCode === hotel.HotelCodes.HotelIffCode
                  )[0]?.TourOperatorCodes.length
                }
              </span>
            )}
          &nbsp;Veranstaltern angeboten.
        </div>
        <div
          style={{
            flexGrow: 1,
            paddingTop: 4,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 16,
          }}
        >
          <div className="offerhotelheader">
            {/*JSON.stringify(offer?.OfferProperties?.OfferIncludes)*/}
            <div className="offerhotelname">
              <span
                className="offerframe2"
                onClick={() => {
                  console.log(offer);
                }}
              >
                {hotel.Name}
              </span>
            </div>
            <div className="offerhotelstars">
              {stars(
                offer.OfferServices.Package.Accommodation.HotelOfferCategory * 1
              )}
            </div>
          </div>

          <div className="offerhotellocation">
            <span className="offerhotlelocationspan">
              in{" "}
              <MdMap
                className="offerframe13"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(setMap(true));
                  setHotelIndex(
                    offer.OfferServices.Package.Accommodation.HotelRef.HotelID
                  );
                }}
              />
              {hotel &&
                hotel.HotelLocationRef &&
                Array.isArray(geodata?.Cities?.City) &&
                geodata.Cities.City.find(
                  (c) => c.CityID === hotel.HotelLocationRef.CityID
                ) !== undefined &&
                geodata.Cities.City.find(
                  (c) => c.CityID === hotel.HotelLocationRef.CityID
                ).Name}{" "}
              ,{" "}
              {hotel &&
                hotel.HotelLocationRef &&
                Array.isArray(geodata?.Regions?.Region) &&
                geodata.Regions.Region.find(
                  (c) => c.RegionID === hotel.HotelLocationRef.RegionID
                ) !== undefined &&
                geodata.Regions.Region.find(
                  (c) => c.RegionID === hotel.HotelLocationRef.RegionID
                ).Name}
              ,{" "}
              {hotel &&
                hotel.HotelLocationRef &&
                Array.isArray(geodata?.Countries?.Country) &&
                geodata.Countries.Country.find(
                  (c) => c.CountryCode === hotel.HotelLocationRef.CountryCode
                ) !== undefined &&
                geodata.Countries.Country.find(
                  (c) => c.CountryCode === hotel.HotelLocationRef.CountryCode
                ).Name}
              <FaInfoCircle
                className="offerframe14"
                onClick={() => {
                  dispatch(getCityInfo({ id: hotel.HotelLocationRef.CityID }));
                  setPopupOpen(true);
                }}
              />
            </span>
          </div>

          <div className="offerframe11">
            {" "}
            <div className="offerframe12" style={{ display: "flex" }}>
              <InfoPopupHover
                nested={true}
                trigger={
                  <div
                    style={{
                      marginRight: 16,
                      cursor: "pointer",
                    }}
                    className="shareicon"
                  >
                    <FiUpload onClick={() => setUploadOpen(true)}></FiUpload>
                  </div>
                }
                content={infos?.uploadsymbol}
                position={"top center"}
              ></InfoPopupHover>
              <Popup
                modal
                closeOnDocumentClick={false}
                onOpen={() =>
                  getLink2Share(offer.OfferID, sessionId, offerInfos, offer)
                    .then((response) => response.json())
                    .then((data) => {
                      setShareLink(data?.ret[0] ? data?.ret[0] : {});
                    })
                    .catch((e) => console.log(e))
                }
                open={uploadOpen}
              >
                <div className="upload1 colordef">
                  <div className="hotelinfoclose">
                    <RiCloseFill
                      onClick={() => {
                        setUploadOpen(false);
                        setUploadStep(0);
                      }}
                      style={{ fontSize: "1.5rem", margin: "auto" }}
                    />
                  </div>
                  {uploadStep === 0 ? (
                    <>
                      <div className="upload2">
                        Wir machen Ihnen gerne ein personalisiertes Angebot zu
                        Ihrer Traumreise
                      </div>
                      <div className="upload10">
                        <div>Name*</div>
                        <input
                          className="upload3"
                          value={requestData.name}
                          onChange={(e) => {
                            setRequestData({
                              ...requestData,
                              name: e.target.value,
                            });
                          }}
                          type="text"
                        ></input>
                      </div>
                      <div className="upload4">
                        <div className="upload5">
                          <div>E-Mail**</div>
                          <input
                            className="upload7"
                            value={requestData.mail}
                            onChange={(e) => {
                              setRequestData({
                                ...requestData,
                                mail: e.target.value,
                              });
                            }}
                            type="text"
                          ></input>
                        </div>
                        <div className="upload6" />
                        <div className="upload5">
                          <div>Telefon**</div>
                          <input
                            className="upload7"
                            value={requestData.phone}
                            onChange={(e) => {
                              setRequestData({
                                ...requestData,
                                phone: e.target.value,
                              });
                            }}
                            type="text"
                          ></input>
                        </div>
                      </div>
                      <div className="upload10">
                        <div>Zusätzliche Informationen</div>
                        <textarea
                          className="upload8"
                          onChange={(e) => {
                            setRequestData({
                              ...requestData,
                              remark: e.target.value,
                            });
                          }}
                          value={requestData.remark}
                          type="text"
                        ></textarea>
                      </div>
                      <div className="upload11">*erforderliche Daten</div>
                      <div className="upload11">
                        **Mail oder Telefon erforderlich
                      </div>
                      <div>
                        <button
                          disabled={
                            !requestData.name ||
                            (!requestData.mail && !requestData.phone)
                          }
                          className={
                            requestData.name &&
                            (requestData.mail || requestData.phone)
                              ? "upload9"
                              : "upload9disabled"
                          }
                          onClick={() => {
                            setUploadStep(1);
                            console.log({
                              ...requestData,
                              link: shareLink.link,
                            });
                            dispatch(
                              sendLink2Agency({
                                ...requestData,
                                link: shareLink.link,
                              })
                            );
                          }}
                        >
                          Senden
                        </button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <div className="wrapper">
                        {" "}
                        <svg
                          className="checkmark"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 52 52"
                        >
                          {" "}
                          <circle
                            className="checkmark__circle"
                            cx="26"
                            cy="26"
                            r="25"
                            fill="none"
                          />{" "}
                          <path
                            className="checkmark__check"
                            fill="none"
                            d="M14.1 27.2l7.1 7.2 16.7-16.8"
                          />
                        </svg>
                      </div>
                      <div className="upload12">Vielen Dank</div>
                      <div className="upload13">
                        Ihre Anfrage wird schnellst möglich bearbeitet
                      </div>
                      <div>
                        <button
                          className="upload9"
                          onClick={() => {
                            setUploadStep(0);
                            setUploadOpen(false);
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </Popup>
              <InfoPopupHover
                trigger={
                  <div
                    style={{
                      marginRight: 16,
                      cursor: "pointer",
                    }}
                    className="shareicon"
                    id="shareicon"
                    onClick={() => {
                      getLink2Share(offer.OfferID, sessionId, offerInfos, offer)
                        .then((response) => response.json())
                        .then((data) => {
                          setShareLink(data?.ret[0] ? data?.ret[0] : {});
                        })
                        .catch((e) => console.log(e));
                    }}
                  >
                    <Popup
                      trigger={(open) => (
                        <div>
                          <FiShare2
                            onClick={() => {
                              getLink2Share(
                                offer.OfferID,
                                sessionId,
                                offerInfos,
                                offer
                              )
                                .then((response) => response.json())
                                .then((data) => {
                                  setShareLink(
                                    data?.ret[0] ? data?.ret[0] : {}
                                  );
                                })
                                .catch((e) => console.log(e));
                            }}
                          />
                        </div>
                      )}
                    >
                      <div className="sharebackground">
                        <MdContentCopy
                          title="Zwischenablage"
                          className="shareicon"
                          onClick={() =>
                            navigator.clipboard.writeText(shareLink.link)
                          }
                        />{" "}
                        <a
                          target="_blank"
                          className="shareicona"
                          href={
                            "https://wa.me/?text=" +
                            encodeURIComponent(
                              shareLink.link + " " + shareLink.info
                            )
                          }
                        >
                          <BsWhatsapp title="WhatsApp" className="shareicon" />
                        </a>
                        <a
                          target="_blank"
                          className="shareicona"
                          href={`mailto:?body=Dieses%20Angebot%20habe%20ich%20für%20Dich%20ausgesucht:%0A%0A${encodeURIComponent(
                            shareLink.link
                          )}%0A&subject=Unsere%20Reiseplanung`}
                        >
                          <AiOutlineMail title="Email" className="shareicon" />
                        </a>
                      </div>
                    </Popup>
                  </div>
                }
                content={infos?.connectsymbol ? infos.connectsymbol : ""}
                position={"top center"}
              ></InfoPopupHover>
              <InfoPopupHover
                trigger={
                  <div style={{ width: "20px", height: "20px" }}>
                    <svg className="hearticon">
                      <defs>
                        <linearGradient
                          id="testGradient"
                          gradientTransform="rotate(90)"
                        >
                          <stop offset="0%" stopColor="rgba(0,0,0,0.5)" />
                          <stop offset="60%" stopColor="rgba(255,255,255,1)" />
                        </linearGradient>
                      </defs>
                      <BsSuitHeartFill
                        className="hearticonfill heartbackground"
                        fill="url(#testGradient)"
                        viewBox="-1 0 18 17"
                      ></BsSuitHeartFill>
                    </svg>
                    <svg className="hearticon">
                      <BsSuitHeartFill
                        className={
                          "hearticonfill " +
                          (Array.isArray(offer.MarketingActions) &&
                          offer.MarketingActions.length > 0 &&
                          offer.MarketingActions[0].marked
                            ? "heartlinefill"
                            : "heartline")
                        }
                        fill="transparent"
                        stroke="black"
                        strokeWidth="3%"
                        viewBox="-1 0 18 17"
                        onClick={() => {
                          setOfferMemo(
                            offer.OfferID,
                            hotel?.HotelCodes?.HotelGiataID,
                            sessionId,
                            dispatch,
                            offerInfos,
                            offer
                          );
                          dispatch(
                            setMarked({
                              offerId: offer.OfferID,
                              marked: !(
                                Array.isArray(offer.MarketingActions) &&
                                offer.MarketingActions.length > 0 &&
                                offer.MarketingActions[0].marked
                              ),
                            })
                          );
                        }}
                      ></BsSuitHeartFill>
                    </svg>
                  </div>
                }
                content={infos?.favoritensymbol ? infos.favoritensymbol : ""}
                position={"top center"}
              ></InfoPopupHover>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <OfferImage
            offer={offer}
            geodata={geodata}
            hotels={hotels}
            imgCount={galleryUrls.length + 1}
            pictIdx={pictIdx}
            setPictIdx={(a) => setPictIdx(a)}
            imgurl={
              pictIdx === 0
                ? hotels.Hotel.find(
                    (e) =>
                      e.HotelID ===
                      offer.OfferServices.Package.Accommodation.HotelRef.HotelID
                  ).HotelImages.LargeImage
                : galleryUrls[pictIdx - 1]
            }
          />
          <div className="offerframe10">
            <div>
              {hotel &&
              hotel.HotelReview &&
              hotel.HotelReview.RatingsCount > 0 ? (
                <div
                  className={
                    hotel.HotelReview.MeanRatingOverall >= 5
                      ? "offerhotelrating excellentrating"
                      : hotel.HotelReview.MeanRatingOverall >= 4
                      ? "offerhotelrating goodrating"
                      : "offerhotelrating normalrating"
                  }
                >
                  <div className="offerhotelratingnumbers">
                    <div className="offerhotelratingrating">
                      <span className="offerhotelratingnumber">
                        {nf1.format(hotel.HotelReview.MeanRatingOverall)}
                      </span>{" "}
                      <span className="offerhotelratingsix">/ 6</span>
                    </div>
                    <div className="offerhotelratingrecommendation">
                      {nf1.format(hotel.HotelReview.MeanRecommendationRate)} %
                    </div>
                  </div>
                  <div className="offerhotelratinginfo">
                    <div className="offerhotelratingtext">
                      {hotel.HotelReview.MeanRatingOverall >= 5 ? (
                        "Sehr Gut"
                      ) : hotel.HotelReview.MeanRatingOverall >= 4 ? (
                        "Gut"
                      ) : hotel.HotelReview.MeanRatingOverall >= 3 ? (
                        "Befriedigend"
                      ) : (
                        <span>&nbsp;</span>
                      )}
                    </div>
                    <div className="offerhotelratingcount">
                      {hotel.HotelReview.RatingsCount} Bewertungen&nbsp;
                    </div>
                    <div className="offerhotelratingrecomm">
                      Weiterempfehlung
                    </div>
                  </div>
                </div>
              ) : (
                <div className="offerhotelrating"></div>
              )}
            </div>
            <div style={{ flexGrow: 1 }}>
              {" "}
              <MarketingBox offer={offer} onpage="0021-0003" />
            </div>
            <div className="offerhotelattributes">
              {hotel &&
                Array.isArray(hotel.HotelAttributes) &&
                hotel.HotelAttributes.map((e, i) => (
                  <React.Fragment key={i}>
                    {i < 5 && (
                      <>
                        {hotelAttributes.find(
                          (a) => e === a.value && !a.hide
                        ) && (
                          <div className="offerhotelattribute" key={e}>
                            <div className="offerhotelattributes1">
                              {hotelAttributes.find((a) => e === a.value) ? (
                                hotelAttributes.find((a) => e === a.value)
                                  .icon ? (
                                  hotelAttributes
                                    .find((a) => e === a.value)
                                    .icon(18)
                                ) : (
                                  <MdCheck
                                    style={{ verticalAlign: "bottom" }}
                                  />
                                )
                              ) : (
                                <MdCheck style={{ verticalAlign: "bottom" }} />
                              )}
                            </div>
                            <div className="offerhotelattributes2">
                              <span className="offerhotelattributetext">
                                {hotelAttributes.find((a) => e === a.value)
                                  ? hotelAttributes.find((a) => e === a.value)
                                      .label
                                  : e}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
          {/*<span className="offerframe5">
            {offer.OfferProperties.OfferFeatures
              ? JSON.stringify(offer.OfferProperties.OfferFeatures)
              : ""}
            <br />
            {offer.OfferProperties.CancellationOption
              ? JSON.stringify(offer.OfferProperties.CancellationOption)
              : ""}
            </span>*/}
          {/*
          <span>
            <br />
            {JSON.stringify(offer)}
          </span>
          */}
          <div style={{}}></div>
          <div className="offerframe6" style={{ marginLeft: 16 }}>
            <div className="offerpersonroom">
              <div className="offerpersonvalue">
                <FormattedMessage
                  id="persons"
                  values={{ num: offer.adults * 1 + offer.children * 1 }}
                />
              </div>
              <div>|</div>
              <div className="offerpersonvalue">
                {multiroomdivider > 1 ? multiroomdivider + " x " : ""}
                {propertyFromArray(
                  roomTypes,
                  offer.OfferServices.Package.Accommodation.Room.RoomType,
                  "value",
                  "label"
                )}
              </div>
            </div>
            <div className="offerpersonroom">
              {holidayType.flight && (
                <>
                  {" "}
                  <div className="offerpersonvalue">
                    {offer.TravelDateInfo.OvernightStays} Übernachtungen
                  </div>
                  <div>|</div>
                  <div className="offerpersonvalue">
                    {offer.TravelDateInfo.TripDuration
                      ? offer.TravelDateInfo.TripDuration
                      : offer.TravelDateInfo.OvernightStays}{" "}
                    Tage
                  </div>
                </>
              )}
              {!holidayType.flight && (
                <div>{offer.TravelDateInfo.OvernightStays} Übernachtungen</div>
              )}
            </div>

            <div className="offerproperties">
              <div className="offerhotelattributes">
                <div className="offerhotelattributes1">
                  <img
                    src="https://holiday.placelogg.com/holidaymedia/Restaurant.png"
                    className="icondefault"
                  />
                </div>{" "}
                <div className="offerhotelattributes2">
                  <span className="offerhotelattributetext">
                    {propertyFromArray(
                      boardTypes,
                      offer.OfferServices.Package.Accommodation.BoardType,
                      "value",
                      "label"
                    )}
                  </span>
                </div>
              </div>
              {offer.OfferServices.Package.Flight && (
                <div className="offerhotelattributes">
                  <div className="offerhotelattributes1">
                    <img
                      src="https://holiday.placelogg.com/holidaymedia/plane.png"
                      className="icondefault"
                    />
                  </div>{" "}
                  <div className="offerhotelattributes2">
                    <span className="offerhotelattributetext">
                      {" "}
                      inkl. Flug{" "}
                      {offer?.OfferServices?.Package?.Flight?.OutboundFlight
                        ?.FlightDeparture?.DepartureAirportRef?.AirportCode && (
                        <>
                          (von{" "}
                          {
                            offer.OfferServices.Package.Flight.OutboundFlight
                              .FlightDeparture.DepartureAirportRef.AirportCode
                          }
                          )
                        </>
                      )}
                    </span>
                  </div>
                </div>
              )}
              {transferincl && (
                <div className="offerhotelattributes">
                  <div className="offerhotelattributes1">
                    <img
                      src="https://holiday.placelogg.com/holidaymedia/Bus.png"
                      className="icondefault"
                    />
                  </div>{" "}
                  <div className="offerhotelattributes2">
                    <span className="offerhotelattributetext">
                      inkl. Hoteltransfer im Zielgebiet
                    </span>
                  </div>
                </div>
              )}
              {railandfly && (
                <div className="offerhotelattributes">
                  <div className="offerhotelattributes1">
                    <img
                      src="https://holiday.placelogg.com/holidaymedia/train.png"
                      className="icondefault"
                    />
                  </div>{" "}
                  <div className="offerhotelattributes2">
                    <span className="offerhotelattributetext">
                      Zug zum Flug
                    </span>
                  </div>
                </div>
              )}
              {rentalCar && (
                <div className="offerhotelattributes">
                  <div className="offerhotelattributes1">
                    <MdCheck size={18} />
                  </div>{" "}
                  <div className="offerhotelattributes2">
                    <span className="offerhotelattributetext">Mietwagen</span>
                  </div>
                </div>
              )}
              <CancellationOptions offer={offer} verbose={false} />
              {freeRebook && (
                <div className="offerhotelattributes">
                  <div className="offerhotelattributes1">
                    <MdCheck size={18} />
                  </div>{" "}
                  <div className="offerhotelattributes2">
                    <span className="offerhotelattributetext">
                      kostenlose Umbuchung
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="offerprice">
              {offer?.checked && (
                <InfoPopupHover
                  trigger={
                    <span>
                      <FaCheckCircle className="offerframeChecked" />
                    </span>
                  }
                  content={infos.checked ? infos.checked : "Checked"}
                  position={"bottom center"}
                ></InfoPopupHover>
              )}
              ab&nbsp;
              <span
                className={
                  offer.realprice &&
                  offer.realprice <
                    offer.PriceInfo.Price.value *
                      (offer.adults * 1 + offer.children * 1) *
                      0.98
                    ? "offerframe8crossed"
                    : offer.realprice >
                      offer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1)
                    ? "offerframe8none"
                    : "offerframe8"
                }
              >
                {offer.PriceInfo.Price.value
                  ? nf.format(
                      offer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1)
                    )
                  : ""}{" "}
              </span>{" "}
              {offer.realprice &&
                offer.realprice <
                  offer.PriceInfo.Price.value *
                    (offer.adults * 1 + offer.children * 1) *
                    0.98 && (
                  <span className="offerframe8new">
                    {nf.format(offer.realprice)}
                  </span>
                )}
              {offer.realprice &&
                offer.realprice >
                  offer.PriceInfo.Price.value *
                    (offer.adults * 1 + offer.children * 1) && (
                  <span className="offerframe8">
                    {nf.format(offer.realprice)}
                  </span>
                )}
              {offer.PriceInfo.Price.CurrencyCode}
              {offer.adults * 1 + offer.children * 1 > 1 && (
                <>
                  <br />(
                  {offer.PriceInfo.Price.value
                    ? nf2.format(
                        offer.realprice &&
                          offer.realprice <
                            offer.PriceInfo.Price.value *
                              (offer.adults * 1 + offer.children * 1) *
                              0.98
                          ? offer.realprice /
                              (offer.adults * 1 + offer.children * 1)
                          : offer.realprice &&
                            offer.realprice >
                              offer.PriceInfo.Price.value *
                                (offer.adults * 1 + offer.children * 1)
                          ? offer.realprice /
                            (offer.adults * 1 + offer.children * 1)
                          : offer.PriceInfo.Price.value
                      )
                    : ""}{" "}
                  {offer.PriceInfo.Price.CurrencyCode} pro Person)
                </>
              )}
            </div>

            {/*Array.isArray(offer?.MarketingActions) && (
          <>
            <br />
            &nbsp;(
            {offer?.MarketingActions[0]?.viewed
              ? "true"
              : offer?.MarketingActions[0]?.viewed === null
              ? "null"
              : "false"}
            /{offer?.MarketingActions[0]?.price}/
            {offer?.MarketingActions[0]?.available
              ? "true"
              : offer?.MarketingActions[0]?.available === null
              ? "null"
              : "false"}
            <br />
            &nbsp;/&nbsp;
            {offer?.MarketingActions[0]?.ldt})
          </>
            )*/}
            <div className="offeractions">
              <InfoPopupHover
                trigger={
                  <span
                    onClick={() => {
                      try {
                        fetch(getHost() + "/searchattributes", {
                          method: "post",
                          body: JSON.stringify({ searchOptions, hotel, offer }),
                          headers: new Headers({
                            "content-type": "application/json",
                          }),
                        })
                          .then((response) => response.json())
                          .then((data) => {
                            let url = window.configData.RESULTS_URL;
                            if (url.indexOf("?") > -1) {
                              url =
                                url +
                                "&flights=" +
                                (holidayType.flight ? "1" : "0") +
                                "&hv=crosscheck&nqid=" +
                                data.qid;
                            } else {
                              url =
                                url +
                                "?flights=" +
                                (holidayType.flight ? "1" : "0") +
                                "&hv=crosscheck&nqid=" +
                                data.qid;
                            }
                            window.open(url, "_blank", "noreferrer");
                          });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                    className="offerframe9"
                  >
                    Crosscheck
                  </span>
                }
                content={infos.crosscheck}
                position={"bottom center"}
              ></InfoPopupHover>
              &nbsp;
              <InfoPopupHover
                trigger={
                  <span
                    className="offerframe9"
                    onClick={() => {
                      try {
                        fetch(getHost() + "/searchattributes", {
                          method: "post",
                          body: JSON.stringify({ searchOptions, hotel, offer }),
                          headers: new Headers({
                            "content-type": "application/json",
                          }),
                        })
                          .then((response) => response.json())
                          .then((data) => {
                            let url = window.configData.RESULTS_URL;
                            if (url.indexOf("?") > -1) {
                              url =
                                url +
                                "&flights=" +
                                (holidayType.flight ? "1" : "0") +
                                "&hv=classic&nqid=" +
                                data.qid;
                            } else {
                              url =
                                url +
                                "?flights=" +
                                (holidayType.flight ? "1" : "0") +
                                "&hv=classic&nqid=" +
                                data.qid;
                            }
                            window.open(url, "_blank", "noreferrer");
                          });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  >
                    Classicview
                  </span>
                }
                content={infos.classicview}
                position={"bottom center"}
              ></InfoPopupHover>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
